module.exports = EXIF;